import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-700 to-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-xl sm:text-2xl font-bold mb-4 font-poppins">Professional Roofing</h3>
            <p className="text-white/90 mb-4 text-sm sm:text-base leading-relaxed">
              Your trusted partner for quality roofing solutions in the Dallas-Fort Worth area. Licensed, insured, and committed to excellence.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-lg transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-lg transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-lg transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4 text-base sm:text-lg">Quick Links</h4>
            <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base">
              <li>
                <Link to="/" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold mb-4 text-base sm:text-lg">Our Services</h4>
            <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base">
              <li>
                <Link to="/services" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Roof Replacement
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Roof Repair
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Insurance Claims
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Roof Inspection
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Emergency Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold mb-4 text-base sm:text-lg">Contact Us</h4>
            <ul className="space-y-3 sm:space-y-4 text-sm sm:text-base">
              <li className="flex items-start">
                <i className="ri-phone-line mr-2 mt-1 flex-shrink-0"></i>
                <a href="tel:+14793366968" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  (479) 336-6968
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line mr-2 mt-1 flex-shrink-0"></i>
                <a href="mailto:info@beyourownroofer.com" className="text-white/90 hover:text-white transition-colors cursor-pointer break-all">
                  info@beyourownroofer.com
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1 flex-shrink-0"></i>
                <span className="text-white/90">
                  Serving Dallas-Fort Worth &amp; Surrounding Areas
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs sm:text-sm">
          <p className="text-white/80 text-center sm:text-left">
            © 2024 Professional Roofing. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center sm:justify-end items-center gap-4 sm:gap-6">
            <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
